import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000/api',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
});

api.interceptors.request.use((config) => {
  try {
    const session = JSON.parse(localStorage.getItem('mhlm.session') || 'null');
    if (session?.token) {
      config.headers.Authorization = `Bearer ${session.token}`;
    }
  } catch { /* noop */ }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      window.dispatchEvent(new CustomEvent('mhlm:auth-401'));
      // Marcamos el error como "esperado" para que las vistas puedan ignorarlo silenciosamente
      error.isAuthExpired = true;
    }
    return Promise.reject(error);
  }
);

/**
 * Wrapper para requests que fallan silenciosamente en caso de 401 o error de red.
 * Devuelve `fallback` si falla. No propaga excepciones (evita overlay de webpack).
 */
export async function safeGet(url, config = {}, fallback = null) {
  try {
    const { data } = await api.get(url, config);
    return data;
  } catch (e) {
    if (e.isAuthExpired) return fallback;
    console.warn('[api.safeGet]', url, e?.message || e);
    return fallback;
  }
}

export default api;
